import { Input, type InputProps } from "@chakra-ui/react"

type WmsLocationFilterInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  maxW?: InputProps["maxW"]
}

// Reusable text filter for WMS screens that filter by location or shelf code.
export function WmsLocationFilterInput({
  value,
  onChange,
  placeholder = "Filtr lokacji / półki",
  maxW = { base: "100%", lg: "240px" },
}: WmsLocationFilterInputProps) {
  return (
    <Input
      size="sm"
      maxW={maxW}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      borderRadius="xl"
    />
  )
}
